import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-143" data-mp="2z2ywkl9ehiyh">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-144" data-mp="2z3h1e6a4p5i0">
        <SectionHeading eyebrow="❓ FAQ" title="Frequently asked questions" data-id="element-145" data-mp="3msjhvat10sax" />

        <ul className="mt-10 flex flex-col gap-3" data-id="element-146" data-mp="3rrwcihq533o2">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-navy-100 bg-white" data-id="element-147" data-mp="3d2gpnctqbidn" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-navy-50 sm:px-5" data-id="element-148" data-mp="9mjbytwczsak">
                  <span className="text-sm font-extrabold text-navy-800 sm:text-base" data-id="element-149" data-mp="1vt6tm9wr3lxn">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sky-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-150" data-mp="25ptf90wwih0q" />
                </button>
                {isOpen ? <p className="px-4 pb-4 text-sm leading-relaxed text-navy-600 sm:px-5 sm:text-base" data-id="element-151" data-mp="2tfnqxf5hhzje">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-152" data-mp="z1wgidfbzbmw">
          <CTAButton label="I’m ready — get instant access" data-id="element-153" data-mp="u2td0xf01dh1" />
        </div>
      </div>
    </section>;
}